import { metaInformation } from "./metaInformation";

export type linkType = "external" | "internal" | "unknown";

export type link = {
  url: string;
  label: string;
} & metaInformation<linkType>;

export function isLink(item: any): item is link {
  return (
    item?.type === "external" ||
    item?.type === "internal" ||
    item?.type === "unknown"
  );
}

export function isLinkExternal(item: link): boolean {
  return item.type === "external";
}

export function isLinkInternal(item: link): boolean {
  return item.type === "internal";
}